import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0dd41f93&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "@/pages/assetManagement/common/style/list.scss?vue&type=style&index=0&id=0dd41f93&lang=scss&scoped=true&external"
import style1 from "./list.vue?vue&type=style&index=1&id=0dd41f93&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd41f93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd41f93')) {
      api.createRecord('0dd41f93', component.options)
    } else {
      api.reload('0dd41f93', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0dd41f93&scoped=true", function () {
      api.rerender('0dd41f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/platformAccount/list.vue"
export default component.exports